import BasePlugin from "../base/BasePlugin";
import HemoStore from "data/HemoStore";

export default class HemoPlugin extends BasePlugin {
    initialize(options) {
        super.initialize(options);

        this.set("name", "Hemo");
        this.set("id", "hemo");
        this.set("fluxContext", "CTX_MappingPlugin_Hemo");

        this.set("fields", [
            {key: "studyid", type: "string", name: "Study ID"},
            {key: "lastname", type: "string", name: "Last Name"},
            {key: "proceduredate", type: "date", name: "Procedure Date"},
            {key: "sitepatientid", type: "string", name: "Site Patient ID"}
        ]);
    }

    hasPaginationParams() {
        return true;
    }

    getQueryLO(query, initiate, interactive) {
        return initiate
            ? HemoStore.getHotLO(query, interactive)
            : HemoStore.getColdLO(query);
    }

    getPagination(query) {
        return HemoStore.getPagination(query);
    }

    getButtonListingPrefix() {
        return "Map From Hemo Record ";
    }
}



// WEBPACK FOOTER //
// ./app/lib/mapping/sources/hemo/HemoPlugin.js